import React from 'react';

/* eslint-disable max-len */
const ViewAllIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "12",
    height: "12",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "3",
    width: "12",
    height: "12",
    rx: "1",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "2.82",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "3",
    width: "12",
    height: "12",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "3",
    width: "12",
    height: "12",
    rx: "1",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-2-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "17",
    width: "12",
    height: "12",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "17",
    y: "17",
    width: "12",
    height: "12",
    rx: "1",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-3-inside-3)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "17",
    width: "12",
    height: "12",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "17",
    width: "12",
    height: "12",
    rx: "1",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-4-inside-4)"
  }));
};
const ViewAllIconDark = _ref2 => {
  let {
    className,
    title
  } = _ref2;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3.99988",
    y: "4",
    width: "11",
    height: "11",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "3.99988",
    y: "4",
    width: "11",
    height: "11",
    rx: "1",
    fill: "#323254",
    stroke: "#323254",
    strokeWidth: "2.82",
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "16.9999",
    y: "4",
    width: "11",
    height: "11",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "16.9999",
    y: "4",
    width: "11",
    height: "11",
    rx: "1",
    fill: "#323254",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-2-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "16.9999",
    y: "17",
    width: "11",
    height: "11",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "16.9999",
    y: "17",
    width: "11",
    height: "11",
    rx: "1",
    fill: "#323254",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-3-inside-3)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3.99988",
    y: "17",
    width: "11",
    height: "11",
    rx: "1"
  })), /*#__PURE__*/React.createElement("rect", {
    x: "3.99988",
    y: "17",
    width: "11",
    height: "11",
    rx: "1",
    fill: "#323254",
    stroke: "#323254",
    strokeWidth: "2.82",
    mask: "url(#path-4-inside-4)"
  }));
};

export { ViewAllIcon, ViewAllIconDark };
